// The survey's layout: resolves the survey for every child route and
// remounts the subtree when the survey changes. A route file's own path IS a
// route — `surveys.$surveyId.results.tsx` nests as this route's CHILD
// (TanStack Router's flat dot-notation) — so the children render through the
// `<Outlet />` below. The index child (`surveys.$surveyId.index.tsx`, the
// survey's own URL) is the survey page; `/results` is the results dashboard.

import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useSurvey } from "@/api/surveys";
import { PageError, PageLoading, useRetry } from "@/components/page-states";

export const Route = createFileRoute("/w/$workspaceId/surveys/$surveyId")({
    // Param-only navigation (one survey's page straight to another's) must
    // remount, or a tab's form keeps the previous survey's defaultValues —
    // react-hook-form only reads defaultValues once, on mount. Remounting
    // here remounts the whole subtree, so no child route needs its own.
    remountDeps: ({ params }) => params,
    component: SurveyLayout,
});

function SurveyLayout() {
    const { surveyId } = Route.useParams();
    const surveyQuery = useSurvey(surveyId);
    const surveyRetry = useRetry(surveyQuery);

    if (surveyRetry.failed) return <PageError level={1} {...surveyRetry.props} />;
    if (surveyQuery.isLoading || !surveyQuery.data) return <PageLoading />;
    return <Outlet />;
}
